import React, { ReactElement } from "react"
import Button from "./Button"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import TransactionSummary, {
  TransactionSummaryData,
} from "./TransactionSummary"
import Text from "./Text"

interface Props {
  onConfirm: () => void
  transactionSummary: TransactionSummaryData
}

function ReviewWithdraw({
  onConfirm,
  transactionSummary,
}: Props): ReactElement {
  const { t } = useTranslation()

  return (
    <Box>
      <Text mb={3}>{t("Please confirm the transaction in your wallet.")}</Text>
      <TransactionSummary data={transactionSummary} />
      <Box mt={3}>
        <Button onClick={onConfirm} fullWidth>
          {t("Confirm")}
        </Button>
      </Box>
    </Box>
  )
}

export default ReviewWithdraw
